import RequiredInput from "../forms/InputHOC"

interface CoordinatesInputsProps {
    formik: any;
}
const CoordinatesInputs: React.FC<CoordinatesInputsProps> = ({ formik }) => {

    // RENDER

    return (
        <div className="grid md:grid-cols-3 grid-cols-1 gap-4 mt-2">

                <RequiredInput
                    id='huso'
                    label="Huso"
                    formik={formik}
                    required
                    className="mb-4"
                />
                <RequiredInput
                    id='coordinatesX'
                    label="Coordenadas X"
                    formik={formik}
                    required
                    className="mb-4"
                />
                    
                <RequiredInput
                    id='coordinatesY'
                    label="Coordenadas Y"
                    formik={formik}
                    required
                    className="mb-4"
                />

        </div>
    )
}

export default CoordinatesInputs